export default __webpack_public_path__ + "static/media/barGraphic_fake.a75b73f5.png";